import React, { useState, useEffect } from 'react'
import { gql } from 'apollo-boost'
import { graphql, withApollo } from 'react-apollo'
import moment from 'moment-timezone'
import queryString from 'query-string'
import { useHistory } from 'react-router-dom'
import { withRouter } from 'react-router'

import AdapterDateFns from '@mui/lab/AdapterDateFns'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { alpha } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import CheckIcon from '@mui/icons-material/Check'
import CircularProgress from '@mui/material/CircularProgress'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import FilterListIcon from '@mui/icons-material/FilterList'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconButton from '@mui/material/IconButton'
import InputLabel from '@mui/material/InputLabel'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import MenuItem from '@mui/material/MenuItem'
import MobileDatePicker from '@mui/lab/MobileDatePicker'
import Paper from '@mui/material/Paper'
import Popover from '@mui/material/Popover'
import Select from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import TextField from '@mui/material/TextField'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { visuallyHidden } from '@mui/utils'

import {
  getBeginningOfTimeStrYYYYMMDD,
  getTenYearsFromNowYYYYMMDD,
  getParamsFromUrl,
  getTodayStrYYYYMMDD
} from '../utils'

import { brRed } from '../colors'
import { ALLOWABLE_DAYS_AHEAD_TO_PLACE_ORDER } from '../constants'


const FILTER_ADMINS = `
  {AND: [{
    user: {
      email: { not_equals: "tracy@broadwayroulette.com" }
    }
  }, {
    user: {
      email: { not_contains: "tracythuynh" }
    }
  }, {
    user: {
      email: { not_equals: "orders@broadwayroulette.com" }
    }
  }, {
    user: {
      email: { not_equals: "devteam@broadwayroulette.com" }
    }
  }]}
`

const headCells = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'type',
    label: 'Type',
  },
  {
    id: 'theaterName',
    label: 'Theatre',
  },
  {
    id: 'runDateStart',
    label: 'Run Date Start',
  },
  {
    id: 'runDateEnd',
    label: 'Run Date End',
  },
  {
    id: 'recommendedAge',
    label: 'Recommended Age',
  },
  {
    id: 'location',
    label: 'Location',
  },
  {
    id: 'showPartner',
    label: 'Show Partner?',
  },
]

const getDateRange = (ownProps) => {
  const queryParams = queryString.parse(ownProps.location.search)

  var startOfPeriod = queryParams.startDate
    ? moment(queryParams.startDate).format('YYYY-MM-DD')
    : getBeginningOfTimeStrYYYYMMDD

  var endOfPeriod = queryParams.endDate
    ? moment(queryParams.endDate).format('YYYY-MM-DD')
    : getTenYearsFromNowYYYYMMDD

  return [startOfPeriod, endOfPeriod]
}

function createData(shows) {
  var formattedData = shows && shows.map(show => {
    const type = show.isMusical ? 'Musical' : 'Play'
    const theater = show.theater ? show.theater.name : 'None assigned'

    return {
      id: show.id,
      name: show.name,
      type: type,
      theaterName: show.theater.name,
      theater: show.theater,
      runDateStart: show.runDateStart,
      runDateEnd: show.runDateEnd,
      recommendedAge: show.recommendedAge,
      location: show.location.name,
      showPartner: show.showPartnerDetails.isShowPartner ? '✔️' : '❌'
    }
  })

  return formattedData
}

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

const FilterPopover = (props) => {
  const {
    startDate,
    endDate,
    executeSearch,
    isSearchingForFamilyFriendly,
    isSearchingForPremium,
    isSearchingForInvalidOrder,
    location,
    searchText,
    setStartDate,
    setEndDate,
    setLocation,
    setIsSearchingForFamilyFriendly,
    setIsSearchingForPremium,
    setIsSearchingForInvalidOrder,
    setSearchText,
    setShowName
  } = props.data

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickButton = (event) => {
    executeSearch()
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'popover' : undefined

  return (
    <div>

      <Tooltip title="Filter list">
        <IconButton aria-describedby={id} onClick={handleClick}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>

      <Popover id={id}
               open={open}
               anchorEl={anchorEl}
               onClose={handleClose}
               anchorOrigin={{
                 vertical: 'bottom',
                 horizontal: 'left',
               }}>

        <div className="filters">
          <h3>Filters</h3>
          <Stack spacing={3} direction="column">
            <div>
              <LocalizationProvider dateAdapter={AdapterDateFns}>

                <Stack spacing={2} direction="column" className="hidemobile stack">
                    <DesktopDatePicker label="Start Date"
                                       inputFormat="MM/dd/yyyy"
                                       value={startDate}
                                       onChange={(newValue) => setStartDate(newValue)}
                                       clearable={true}
                                       renderInput={(params) => <TextField {...params} />} />

                    <DesktopDatePicker label="End Date"
                                       inputFormat="MM/dd/yyyy"
                                       value={endDate}
                                       onChange={(newValue) => setEndDate(newValue)}
                                       clearable={true}
                                       renderInput={(params) => <TextField {...params} />} />
                </Stack>

                <Stack spacing={2} direction="column" className="showmobile stack">
                  <MobileDatePicker label="Start date"
                                    inputFormat="MM/dd/yyyy"
                                    value={startDate}
                                    onChange={(newValue) => setStartDate(newValue)}
                                    renderInput={(params) => <TextField {...params} />} />

                  <MobileDatePicker label="End date"
                                    inputFormat="MM/dd/yyyy"
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    renderInput={(params) => <TextField {...params} />} />
                </Stack>
              </LocalizationProvider>
            </div>

            <div>
              <TextField id="outlined-basic"
                         label="Show or Theatre"
                         variant="outlined"
                         onChange={(event) => setSearchText(event.target.value)} />
            </div>

            <div>
              <Stack spacing={2} direction="column">
                <FormControlLabel
                  control={<Checkbox checked={isSearchingForFamilyFriendly}
                                     className="search-checkbox"
                                     onChange={(event) => setIsSearchingForFamilyFriendly(event.target.checked)} />}
                  label="Show Only Family Friendly" />
              </Stack>
            </div>

            <div>
              <Stack spacing={2} direction="row">

                <FormControl fullWidth>
                  <InputLabel id="select-label">Location</InputLabel>
                  <Select labelId="select-label"
                          id="select"
                          value={location}
                          label="Location"
                          onChange={(event) => setLocation(event.target.value)}>
                    <MenuItem value="Broadway">Broadway</MenuItem>
                    <MenuItem value="West End">West End</MenuItem>
                  </Select>
                </FormControl>

              </Stack>
            </div>

            <Button variant="contained" onClick={handleClickButton}>Search</Button>
          </Stack>
        </div>

      </Popover>
    </div>
  )
}

const EnhancedTableHead = (props) => {
  const { order, orderBy, rowCount, onRequestSort } = props

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell key={headCell.id}
                     align='left'
                     padding={'normal'}
                     sortDirection={orderBy === headCell.id ? order : false}>

            <TableSortLabel active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>

          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

const EnhancedTableToolbar = (props) => {
  const { history } = props

  const handleClickNew = async () => {
    try {
      const result = await props.client.mutate({
        mutation: SHOW_CREATE_MUTATION
      })

      history.push(`/show/${result.data.showCreate.id}`)
    } catch(err) {
      alert(`Unable to create show: ${err.message}`)
    }
  }

  return (
    <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 }}}>
      <Typography sx={{ flex: '1 1 100%' }} variant="h3" className="page-title" component="div">
        Shows <AddCircleIcon fontSize="large" onClick={() => { handleClickNew() }} />
      </Typography>

      <FilterPopover data={props}/>
    </Toolbar>
  )
}

function ShowList(props) {
  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('orderPlacedAt')

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [location, setLocation] = useState('Broadway')
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [searchText, setSearchText] = useState('')

  const [loadingSearch, setLoadingSearch] = useState(false)
  const [error, setError] = useState(false)
  const [searchedItems, setSearchedItems] = useState(null)

  const [isSearchingForFamilyFriendly, setIsSearchingForFamilyFriendly] = useState(false)

  const history = useHistory()

  const executeSearch = async () => {
    try {
      setLoadingSearch(true)

      var endOfPeriod = endDate ? moment(endDate).format('YYYY-MM-DD') : getTenYearsFromNowYYYYMMDD()
      var startOfPeriod = startDate ? moment(startDate).format('YYYY-MM-DD') : getBeginningOfTimeStrYYYYMMDD()
      var familyOnlyFilter = isSearchingForFamilyFriendly ? `{ isChildFriendly: { equals: true }}` : ''

      var filterShowQuery = gql`
        query ShowsListQuery($searchText: String, $location: String, $startOfPeriod: Date, $endOfPeriod: Date) {
          showsList (
            first: 1000,
            sort: { createdAt : DESC },
            filter: {
              AND: [
                { runDateStart: { gte: $startOfPeriod }},
                { runDateEnd: { lte: $endOfPeriod }},
                { isForOffBroadway: { equals: false }},
                { location: { name: { equals: $location }}}

                ${familyOnlyFilter}

                {OR: [
                  { theater: { name: { contains: $searchText }} },
                  { name: { contains: $searchText }},
                  { shortName: { contains: $searchText }}
                ]},
              ]
            }
          ) {
            items {
              id
              createdAt
              isChildFriendly
              isMusical
              name
              recommendedAge
              runDateEnd
              runDateStart
              shortName

              location {
                id
                name
              }

              showPartnerDetails {
                isShowPartner
              }

              theater {
                id
                name
              }
            }
          }
        }
      `

      var result = await props.client.query({
        query: filterShowQuery,
        variables: {
          searchText,
          endOfPeriod,
          startOfPeriod,
          location,
        }
      })

      const shows = result.data.showsList.items
      setSearchedItems(shows)

      setSearchText('')
      setLocation('Broadway')
      setEndDate(null)
      setStartDate(null)
      setLoadingSearch(false)

    } catch(err) {
      setError(true)
      setLoadingSearch(false)
      console.log(err)
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const getItemsToRender = () => {
    return (searchedItems || props.showsListQuery.showsList && props.showsListQuery.showsList.items)
  }

  const items = getItemsToRender()
  const rows = createData(items)

  const emptyRows = page > 0 && rows ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0

  return (
    <Box sx={{ width: '100%' }}>
      <div className='data'>
        <EnhancedTableToolbar client={props.client}
                              endDate={endDate}
                              executeSearch={executeSearch}
                              history={history}
                              isSearchingForFamilyFriendly={isSearchingForFamilyFriendly}
                              location={location}
                              searchText={searchText}
                              startDate={startDate}
                              setEndDate={setEndDate}
                              setLocation={setLocation}
                              setIsSearchingForFamilyFriendly={setIsSearchingForFamilyFriendly}
                              setSearchText={setSearchText}
                              setStartDate={setStartDate} />

        {(loadingSearch || !rows && props.showsListQuery && props.showsListQuery.loading) &&
          <CircularProgress />
        }

        {(!rows && props.showsListQuery && props.showsListQuery.error) || error &&
          <h2>Error</h2>
        }

        {rows && !loadingSearch &&
          <div>
            <TableContainer>
              <Table sx={{ minWidth: 750 }}
                     aria-labelledby="table-title"
                     size='medium'>

                <EnhancedTableHead order={order}
                                   orderBy={orderBy}
                                   onRequestSort={handleRequestSort}
                                   rowCount={rows.length}/>
                <TableBody>

                  {rows.slice().sort(getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const labelId = `enhanced-table-checkbox-${index}`

                      const id = (<a href={'/show/' + row.id}>{row.id}</a>)
                      const showName = (<a href={'/show/' + row.id}>{row.name}</a>)
                      const theatreName = row.theater
                                          ? (<a href={'/theater/' + row.theater.id}>{row.theaterName}</a>)
                                          : row.theaterName

                      return (
                        <TableRow hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.id}>

                          <TableCell component="th"
                                     id={labelId}
                                     scope="row"
                                     padding="none">
                            {id}
                          </TableCell>
                          <TableCell align="left">{showName}</TableCell>
                          <TableCell align="left">{row.type}</TableCell>
                          <TableCell align="left">{theatreName}</TableCell>
                          <TableCell align="left">{row.runDateStart}</TableCell>
                          <TableCell align="left">{row.runDateEnd}</TableCell>
                          <TableCell align="left">{row.recommendedAge}</TableCell>
                          <TableCell align="left">{row.location}</TableCell>
                          <TableCell align="left">{row.showPartner}</TableCell>
                        </TableRow>
                      )
                    })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }} >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}

                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination rowsPerPageOptions={[5, 10, 25, 50, 100]}
                             component="div"
                             count={rows.length}
                             rowsPerPage={rowsPerPage}
                             page={page}
                             onPageChange={handleChangePage}
                             showFirstButton={true}
                             showLastButton={true}
                             onRowsPerPageChange={handleChangeRowsPerPage}/>
          </div>
        }
      </div>
    </Box>
  )
}

const SHOWS_LIST_QUERY = gql`
  query ShowsListQuery($location: String, $runDateStart: Date, $runDateEnd: Date) {
    showsList(
      sort: { name : ASC }
      filter: {
        isForOffBroadway: { equals: false },
        runDateStart: { lte: $runDateStart },
        runDateEnd: { gte: $runDateEnd },
        location: { name: { equals: $location }}
      }
    ) {
      items {
        id
        createdAt
        isChildFriendly
        isMusical
        name
        recommendedAge
        runDateEnd
        runDateStart
        shortName

        location {
          id
          name
        }

        showPartnerDetails {
          isShowPartner
        }

        theater {
          id
          name
        }
      }
    }
  }
`

const SHOW_CREATE_MUTATION = gql`
  mutation ShowCreateMutation {
    showCreate(data: {
      name: "Fill me out"
      shortName: "Fill me out"
      slug: "Fill me out"
      isChildFriendly: false
      isMusical: true
      isForOffBroadway: false

      location: {
        connect: { name: "Broadway" }
      }

      showPartnerDetails: {
        create: {}
      }
    }) {
      id
    }
  }
`

export default withRouter(withApollo(graphql(SHOWS_LIST_QUERY, {
  name: 'showsListQuery',
  options: (ownProps) => {
    var today = moment().format('YYYY-MM-DD')
    var runDateCutoff = moment().add(ALLOWABLE_DAYS_AHEAD_TO_PLACE_ORDER, 'days').format('YYYY-MM-DD')

    return {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        runDateEnd: today,
        runDateStart: runDateCutoff,
        location: "Broadway"
      }
    }
  }
})(ShowList)))
